import React from 'react'
import Logo from './Logo'
import NavigationMenu from './NavigationMenu'
import { Link } from 'react-router-dom'

const Header: React.FC = () => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200 flex-shrink-0 py-5 px-3 sm:px-3 lg:px-4 fixed w-full z-50">
      <div className="flex justify-between items-center">
        <Link to="/">
          <Logo />
        </Link>
        <div className="flex items-center gap-3">
          <Link
            to="/login"
            className="group md:max-w-xs relative flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Login
          </Link>
          <NavigationMenu />
        </div>
      </div>
    </header>
  )
}

export default Header
